import React, { useState, useEffect } from 'react';
import { Space, Typography, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { motion, AnimatePresence } from 'framer-motion';

const { Text } = Typography;

const funnyLoadingMessages = [
  "🌌 Consulting with the AI council of elders...",
  "🕳️ Retrieving quantum data from a black hole...",
  "🔮 Predicting at least three possible futures...",
  "🤖 Teaching AI the meaning of life...",
  "🎨 Painting your workflow with digital crayons...",
  "🧪 Mixing coffee with code for extra creativity...",
  "🎲 Rolling D20 for workflow optimization...",
  "🎯 Calculating the meaning of 42...",
  "🔄 Converting caffeine into code...",
  "🎩 Pulling workflow rabbits out of digital hats...",
  "🌈 Harnessing unicorn power for processing...",
  "🧩 Solving the workflow puzzle with AI magic...",
  "🎮 Speedrunning workflow generation...",
  "📚 Reading all of Wikipedia really quickly...",
  "🎸 Teaching AI to play air guitar...",
  "🌟 Sprinkling digital fairy dust...",
  "🔧 Tightening the last few quantum bolts...",
  "🎪 Juggling ones and zeros...",
  "🎨 Picking the perfect shade of binary..."
];

const WorkflowGenerationLoader = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => 
        (prevIndex + 1) % funnyLoadingMessages.length
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2000,
        backdropFilter: 'blur(4px)',
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          padding: '40px',
          borderRadius: '16px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          maxWidth: '500px',
          width: '90%',
          textAlign: 'center',
        }}
      >
        <Spin 
          size="large"
          style={{ marginBottom: 24 }}
          indicator={
            <LoadingOutlined 
              style={{ fontSize: 48, color: '#1890ff' }} 
              spin 
            />
          }
        />

        <AnimatePresence mode="wait">
          <motion.div
            key={currentMessageIndex}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
          >
            <Text style={{ fontSize: '18px', marginBottom: '16px', display: 'block' }}>
              {funnyLoadingMessages[currentMessageIndex]}
            </Text>
          </motion.div>
        </AnimatePresence>

        <Text type="secondary" style={{ fontSize: '14px' }}>
          Building your custom workflow...
        </Text>
      </motion.div>
    </div>
  );
};

export default WorkflowGenerationLoader;